import md5 from 'md5';

export async function encryptData(data: string, key: string): Promise<string> {
    const keyBuffer = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(key));
    const iv = window.crypto.getRandomValues(new Uint8Array(16));
    const algorithm = { name: 'AES-CBC', iv };
    const keyObject = await window.crypto.subtle.importKey('raw', keyBuffer, { name: 'AES-CBC' }, false, ['encrypt']);
    const encryptedBuffer = await window.crypto.subtle.encrypt(algorithm, keyObject, new TextEncoder().encode(data));
    const resultBuffer = new Uint8Array(iv.length + encryptedBuffer.byteLength);

    resultBuffer.set(iv);
    resultBuffer.set(new Uint8Array(encryptedBuffer), iv.length);

    return encodeURIComponent(btoa(String.fromCharCode.apply(null, (resultBuffer as unknown as number[]))));
}

export function generateToken(value: string, salt: string): string {
    return md5(value + salt);
}

export function validateToken(token: string, value: string, salt: string): boolean {
    if (token === generateToken(value, salt)) {
        return true;
    }

    return false;
}

export function getEnvTokenSalt(): string {
    return process.env.SECRET_TOKEN_SALT ?? 'default';
}
